import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '~/components/common/MicroFrontEnds';
import { logInfo, generateErrorLogger } from '~/utilities/loggers';

const CHAT_SHAQBOT_MODULE = 'CarvanaChatShaqbot';

const logChatShaqbotError = generateErrorLogger('Chat Shaqbot MFE');

export default function ShaqbotChatMfe() {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          CHAT_SHAQBOT_MODULE,
          [
            {
              component: 'default',
              default: {
                file: 'main.js',
                manifest: `${
                  process.env.CVNA_APP_CHAT_SHAQBOT_BASE_URL
                }/build/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  return (
    <MfeReactComponent
      component="default"
      module={CHAT_SHAQBOT_MODULE}
      onComponentLoaded={() => {
        logInfo('Chat Shaqbot MFE loaded', {
          module: CHAT_SHAQBOT_MODULE
        });
      }}
      onComponentError={error => {
        logChatShaqbotError(error, {
          module: CHAT_SHAQBOT_MODULE,
          errorType: 'component_load_failure'
        });
      }}
    />
  );
}
